import { gql } from "@apollo/client"; // saveVisitaParenteral.js

import { adaptIndicacionVisitaBAPInput } from "../../../../Pages/MisVisitasCreation/utils/adaptSubModelsInput";

const SAVE_VISITA_PARENTERAL = gql`
  mutation saveVisitaParenteral($input: AddVisitaParenteralInput!) {
    saveVisitaParenteral(input: $input) {
      idVisita
      idVisitaParenteral
    }
  }
`;

export default SAVE_VISITA_PARENTERAL;

export const adaptAddVisitaParenteralInput = (data) => ({
  idVisitaParenteral: data?.idVisitaParenteral,
  idComboRIValorKarnofsky: data?.idComboRIValorKarnofsky,
  ingestaOral: !!data?.ingestaOral,
  gerFormula: data?.gerFormula,
  idComboRIValorTipoCateter: data?.idComboRIValorTipoCateter,
  justificacionTransitorio: data?.justificacionTransitorio,
  fechaColocacion: data?.fechaColocacion,
  idComboRIValorUbicacionCateter: data?.idComboRIValorUbicacionCateter,
  idComboRIValorLumenes: data?.idComboRIValorLumenes,
  insercionNormal: !!data?.insercionNormal,
  justificacionInsercion: data?.justificacionInsercion,
  idComboRIValorModoInfusion: data?.idComboRIValorModoInfusion,
  justificacionModificacion: data?.justificacionModificacion,
  idComboRIValorSellado: data?.idComboRIValorSellado,
  cantidadHorasMagistral: data?.cantidadHorasMagistral || 24,
  flujoMagistral: data?.flujoMagistral,
  cantidadHorasEstandar: data?.cantidadHorasEstandar || 24,
  flujoEstandar: data?.flujoEstandar,
  cantidadEscalonesMagistral: data?.cantidadEscalonesMagistral,
  duracionMesetaMagistral: data?.duracionMesetaMagistral,
  cicloMagistral: data?.cicloMagistral,
  cantidadEscalonesEstandar: data?.cantidadEscalonesEstandar,
  duracionMesetaEstandar: data?.duracionMesetaEstandar,
  cicloEstandar: data?.cicloEstandar,
  expansion: !!data?.expansion,
  idComboVisitaValorProducto: data?.idComboVisitaValorProducto,
  volumen: data?.volumen,
  idComboVisitaValorExpansion: data?.idComboVisitaValorExpansion,
  flujo: data?.flujo,
  indicacionComentario: data?.indicacionComentario,
  indicacionEspecial: data?.indicacionEspecial,
  calorias: data?.calorias,
  hidratosCarbono: data?.hidratosCarbono,
  proteinas: data?.proteinas,
  lipidos: data?.lipidos,
  proteinasTotales: data?.proteinasTotales,
  lipidosTotales: data?.lipidosTotales,
  caloriasTotales: data?.caloriasTotales,
  idIndicacionVisitaBAP: data?.idIndicacionVisitaBAP,
  diasConexionSemanaMagistral: data?.diasConexionSemanaMagistral,
  diasConexionSemanaEstandar: data?.diasConexionSemanaEstandar,
  indicacionVisitaBAP: adaptIndicacionVisitaBAPInput(data),
  complicaciones: data?.complicaciones,
  idVisita: data?.idVisita
});